export const SignInTitle = ({ title }: { title: string }) => {
  return <h1 className='typography-level-3 font-graphik-compact font-semibold text-center'>{title}</h1>;
};

export const Divider = () => {
  return (
    <div className='flex items-center justify-center gap-lg w-full max-w-[328px]'>
      <div className='w-full stroke-helper border-t h-px' />
      <span className='text-center text-secondary typography-default'>OR</span>
      <div className='w-full stroke-helper border-t h-px' />
    </div>
  );
};
